export const environment = {
    production: false,

    hosts: ['http://localhost:4200', 'https://foundry-dev.thinglogix.com'],

    // Foundry information
    fndyApiGatewayEndpoint: 'https://homeapi.thinglogix.com',
    fndySecureApiGatewayKey: 'SKdUisRgpj8HbWbOD2mBa3nbXQqv7bxO8Ii0kZOz',
    liquidInsightAccountId: 'e12ea630-788f-11ec-a650-a367ad5a917b',
    kegTypeId: 'f4b20950-8527-11ec-996b-c79755c7278e',
    foundryHomeEndpoint: 'https://homeapi.thinglogix.com',
    foundryHomeApiKey: 'SKdUisRgpj8HbWbOD2mBa3nbXQqv7bxO8Ii0kZOz',
    fndyAccountId: '001868e1-3bf8-11eb-a753-a114e418d7f0',
    fndyCognitoIdentityPoolId: 'us-west-2:9aa21821-c305-42f1-96ad-5ed64f6e12be',
    fndyDeveloperProviderName: 'com.liquidinsight.foundry',
    googleMapsApiKey: 'AIzaSyDl2sRjMNN6fm4MidKBic3XUP990Lb4s3w',
    sensorTypeId: '0e1d22f0-7a22-11ec-bb91-cdba4dbd7b2d',
    skuTypeId: '2699fec0-7ef0-11ec-97bf-cfcb819cf8b0',
    ublAlertTypeId: '70bb3a80-7d31-11eb-8f23-3932cb0f68b4',
};
